import { useSelector } from 'react-redux';

import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import * as offerSelectors from '@makemydeal/dr-dash-store/selectors/offerSelectors';

import { AVERAGE_MONTHLY_PAYMENT_LABEL } from '../../constants';
import type { FlexBuyPaymentFigureField } from '../types';

export const useAvgMonthlyPaymentField = (): FlexBuyPaymentFigureField => {
    // TODO: Wee need to verify if this is the correct selector to use, we are assuming it is correct, maybe need check another variable like `isAveragePaymentAmount` before use it
    const monthlyPayment = useSelector(offerSelectors.getMonthlyPayment);

    return { label: AVERAGE_MONTHLY_PAYMENT_LABEL, value: formatDollarsAndCents(monthlyPayment) };
};
